import { useGlobalPublicConfig } from '@/shared/hooks/use-global-config'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'
import { Input } from '@/shared/ui/input'
import { Label } from '@/shared/ui/label'

const sectionTitleClass = 'text-sm font-medium text-muted-foreground'

export function HotelHoursCard() {
    const { data: globalPublicConfig, setGlobalPublicConfig } = useGlobalPublicConfig()

    const updateMorning = (field: 'open' | 'close', value: string) => {
        setGlobalPublicConfig({
            ...globalPublicConfig,
            hotelHours: {
                ...globalPublicConfig.hotelHours,
                morning: {
                    ...globalPublicConfig.hotelHours?.morning,
                    [field]: value,
                },
            },
        })
    }

    const updateAfternoon = (field: 'open' | 'close', value: string) => {
        setGlobalPublicConfig({
            ...globalPublicConfig,
            hotelHours: {
                ...globalPublicConfig.hotelHours,
                afternoon: {
                    ...globalPublicConfig.hotelHours.afternoon,
                    [field]: value,
                },
            },
        })
    }

    return (
        <Card>
            <CardHeader className='pb-4'>
                <CardTitle className='text-lg'>Horarios del hotel</CardTitle>
            </CardHeader>
            <CardContent className='space-y-4'>
                <div className='space-y-2'>
                    <p className={sectionTitleClass}>Mañana</p>
                    <div className='grid grid-cols-2 gap-3'>
                        <div className='space-y-2'>
                            <Label>Apertura</Label>
                            <Input
                                type='time'
                                value={globalPublicConfig.hotelHours.morning?.open || ''}
                                onChange={e => updateMorning('open', e.target.value)}
                            />
                        </div>
                        <div className='space-y-2'>
                            <Label>Cierre</Label>
                            <Input
                                type='time'
                                value={globalPublicConfig.hotelHours.morning?.close || ''}
                                onChange={e => updateMorning('close', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='space-y-2'>
                    <p className={sectionTitleClass}>Tarde</p>
                    <div className='grid grid-cols-2 gap-3'>
                        <div className='space-y-2'>
                            <Label>Apertura</Label>
                            <Input
                                type='time'
                                value={globalPublicConfig.hotelHours.afternoon?.open || ''}
                                onChange={e => updateAfternoon('open', e.target.value)}
                            />
                        </div>
                        <div className='space-y-2'>
                            <Label>Cierre</Label>
                            <Input
                                type='time'
                                value={globalPublicConfig.hotelHours.afternoon?.close || ''}
                                onChange={e => updateAfternoon('close', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
